var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoutIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(72.941176%,75.294118%,80%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 10 17.5 L 4.16626 17.5 C 3.724365 17.5 3.300781 17.324219 2.988281 17.011719 C 2.675781 16.699219 2.5 16.275635 2.5 15.83374 L 2.5 4.16626 C 2.5 3.724365 2.675781 3.300781 2.988281 2.988281 C 3.300781 2.675781 3.724365 2.5 4.16626 2.5 L 10 2.5 ",
    transform: "matrix(3.2,0,0,3.2,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(72.941176%,75.294118%,80%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 13.33252 14.16626 L 17.5 10 L 13.33252 5.83374 ",
    transform: "matrix(3.2,0,0,3.2,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(72.941176%,75.294118%,80%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 17.5 10 L 7.5 10 ",
    transform: "matrix(3.2,0,0,3.2,0,0)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout_icon.e7b9b855ab766def6b77cefe2a974622.svg";
export { ForwardRef as ReactComponent };